import { redirect } from "react-router-dom";
import supabaseAuthProviderService, {
  useSupabaseAuthProviderService,
} from "../../../services/supabase-auth-provider.service";

export const logout = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  const response = await supabaseClient.auth.signOut({
    scope: "local",
  });

  if (response.error) {
    await supabaseClient.auth.refreshSession();

    throw response.error;
  }

  // StorageService.removeItem(StorageKeys.DIRECTORY_TOKEN);
  supabaseAuthProviderService.clearPersistedProvider();

  redirect("/login");
};

export const login = async (email: string, password: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  const response = await supabaseClient.auth.signInWithPassword({
    email,
    password,
  });

  if (response.error) {
    throw response.error;
  }
};

export const updatePassword = async (password: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  const response = await supabaseClient.auth.updateUser({ password });

  if (response.error) {
    throw response.error;
  }
};

export const refreshSession = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  const response = await supabaseClient.auth.refreshSession();

  if (response.error) {
    throw response.error;
  }

  return response;
};

export const signOut = async () => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  return supabaseClient.auth.signOut({ scope: "local" });
};

export const signInWithSSO = async (ssoProviderId: string, redirectTo: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  console.log("signInWithSSO", { ssoProviderId, redirectTo });

  return supabaseClient.auth.signInWithSSO({
    providerId: ssoProviderId,
    options: {
      redirectTo,
    },
  });
};

// TODO: probably can be removed
export const setSession = async (accessToken: string, refreshToken: string) => {
  const supabaseClient = useSupabaseAuthProviderService.getState().client;

  if (!supabaseClient) {
    throw new Error("Supabase client not found");
  }

  return supabaseClient.auth.setSession({
    access_token: accessToken,
    refresh_token: refreshToken,
  });
};
